export enum EnvironmentTypes {
    VSA = 'vsa',
    MSS = 'ss',
}
